import { render, staticRenderFns } from "./ed-section-object-homework-info.vue?vue&type=template&id=173f2bfa&scoped=true&"
import script from "./ed-section-object-homework-info.ts?vue&type=script&lang=ts&"
export * from "./ed-section-object-homework-info.ts?vue&type=script&lang=ts&"
import style0 from "./ed-section-object-homework-info.scss?vue&type=style&index=0&id=173f2bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173f2bfa",
  null
  
)

export default component.exports